import { render, staticRenderFns } from "./MenuCarouselSectionModule.vue?vue&type=template&id=42905d21&"
import script from "./MenuCarouselSectionModule.vue?vue&type=script&lang=js&"
export * from "./MenuCarouselSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports